import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import _ from 'lodash';

import { Selection } from '../Common/selection';
import { toFromDates } from '../Common/cleanDates';
import ContentWrapper from '../Layout/ContentWrapper';
import { InputField } from '../Common/inputField';
import RMAAutoSuggest from './RMAAutoSuggest';
import { ROOT_URL, ROOT_API_URL } from '../../actions/root_url';

const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';

const getOptionValue = option => {
  if (typeof option === 'object') {
    return option.value
  }
  return option;
}

const getOptionLabel = (customer, customerOptions) => {
  if (typeof customer === 'object') {
    return customer.label;
  }
  let label = '';
  _.forEach(customerOptions, c => {
    if (c.value === customer) {
      label = c.label;
    }
  });
  return label;
}

const fixingStatus = [
  { label: 'UNRECEIVED', value: 'UNRECEIVED' },
  { label: 'RECEIVED', value: 'RECEIVED' },
  { label: 'REPAIRING', value: 'REPAIRING' },
  { label: 'REPAIRED', value: 'REPAIRED' },
  { label: 'DISPATCHED', value: 'DISPATCHED' },
];

const processStatus = [{
  label: 'Unreceived',
  value: 'unreceived'
}, {
  label: 'Received',
  value: 'received',
}, {
  label: 'Checking',
  value: 'checking',
}, {
  label: 'Repairing',
  value: 'repairing',
}, {
  label: 'Complete',
  value: 'complete',
}]

const solutionOptions = [{
  label: '电池-内部短路-报废-L.40mins-R.0$-Lv0',
  value: '电池-内部短路-报废-L.40mins-R.0$-Lv0',
}, {
  label: '电池-充电口坏-换充电口-L.40mins-R.45$-Lv4',
  value: '电池-充电口坏-换充电口-L.40mins-R.45$-Lv4',
}, {
  label: '电池-电池上盖坏-换电池上盖-L.40mins-R.45$-Lv4',
  value: '电池-电池上盖坏-换电池上盖-L.40mins-R.45$-Lv4',
}, {
  label: '电池-电量显示灯坏-换电量显示灯-L.40mins-R.45$-Lv4',
  value: '电池-电量显示灯坏-换电量显示灯-L.40mins-R.45$-Lv4',
}, {
  label: '后拔链器脱落或卡进轮子里-仅拔链器坏-换拔链器-L.30mins-R.35$-Lv3',
  value: '后拔链器脱落或卡进轮子里-仅拔链器坏-换拔链器-L.30mins-R.35$-Lv3',
}, {
  label: '后拔链器脱落或卡进轮子里-车架吊耳坏-换吊耳-L.10mins-R.15$-Lv1',
  value: '后拔链器脱落或卡进轮子里-车架吊耳坏-换吊耳-L.10mins-R.15$-Lv1',
}, {
  label: '后拔链器脱落或卡进轮子里-链条坏-换链条-L.30mins-R.35$-Lv3',
  value: '后拔链器脱落或卡进轮子里-链条坏-换链条-L.30mins-R.35$-Lv3',
}, {
  label: '后拔链器脱落或卡进轮子里-飞轮卡坏-换飞轮-L.15mins-R.25$-Lv2',
  value: '后拔链器脱落或卡进轮子里-飞轮卡坏-换飞轮-L.15mins-R.25$-Lv2',
}, {
  label: '脚踩无助力-助力传感器坏-换飞轮-L.15mins-R.25$-Lv2',
  value: '脚踩无助力-助力传感器坏-换飞轮-L.15mins-R.25$-Lv2',
}, {
  label: '刹车太松或失灵-机械碟刹-调紧刹车线-L.5mins-R.15$-Lv1',
  value: '刹车太松或失灵-机械碟刹-调紧刹车线-L.5mins-R.15$-Lv1',
}, {
  label: '刹车太松或失灵-油压碟刹漏油-加矿物油-L.5mins-R.15$-Lv1',
  value: '刹车太松或失灵-油压碟刹漏油-加矿物油-L.5mins-R.15$-Lv1',
}, {
  label: '刹车太松或失灵-油压碟刹进气-排气-L.5mins-R.15$-Lv1',
  value: '刹车太松或失灵-油压碟刹进气-排气-L.5mins-R.15$-Lv1',
}, {
  label: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L.15mins-R.25$-Lv2',
  value: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L.15mins-R.25$-Lv2',
}, {
  label: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L.15mins-R.25$-Lv2',
  value: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L.15mins-R.25$-Lv2',
}, {
  label: '电机不启动-刹把断电了-恢复刹把或换断电线-L.30mins-R.35$-Lv3',
  value: '电机不启动-刹把断电了-恢复刹把或换断电线-L.30mins-R.35$-Lv3',
}, {
  label: '电机不启动-电机坏-换电机-L.30mins-R.35$-Lv3',
  value: '电机不启动-电机坏-换电机-L.30mins-R.35$-Lv3',
}, {
  label: '电机不启动-控制器坏-换控制器-L.30mins-R.35$-Lv3',
  value: '电机不启动-控制器坏-换控制器-L.30mins-R.35$-Lv3',
}, {
  label: '电机不启动-主线束坏-换主线束-L.30mins-R.35$-Lv3',
  value: '电机不启动-主线束坏-换主线束-L.30mins-R.35$-Lv3',
}, {
  label: '后轮摇摆-辐条松-校正辐条-L.无法操作-R.0$-UNABLE',
  value: '后轮摇摆-辐条松-校正辐条-L.无法操作-R.0$-UNABLE',
}, {
  label: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L.5mins-R.15$-Lv1',
  value: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L.5mins-R.15$-Lv1',
}, {
  label: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L.5mins-R.15$-Lv1',
  value: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L.5mins-R.15$-Lv1',
}, {
  label: '仪表显示故障/屏幕坏-换仪表-L.5mins-R.15$-Lv1',
  value: '仪表显示故障/屏幕坏-换仪表-L.5mins-R.15$-Lv1',
}, {
  label: '前叉漏油-换前叉-换仪表-L.30mins-R.35$-Lv3',
  value: '前叉漏油-换前叉-换仪表-L.30mins-R.35$-Lv3',
}, {
  label: '曲柄坏-换曲柄-L.30mins-R.35$-Lv3',
  value: '曲柄坏-换曲柄-L.30mins-R.35$-Lv3',
}, {
  label: '链盘坏-换链盘-L.30mins-R.35$-Lv3',
  value: '链盘坏-换链盘-L.30mins-R.35$-Lv3',
}, {
  label: '内胎/衬带坏-换内胎/衬带-L.15-30mins-R.35$-Lv3',
  value: '内胎/衬带坏-换内胎/衬带-L.15-30mins-R.35$-Lv3',
}];

const customerNoteShortcuts = {
  2: [{
    label: '质检',
    value: '质检',
  }, {
    label: 'L0全产品,刷固件/校准/清洁/外观总成或更换维修',
    value: 'L0全产品,刷固件/校准/清洁/外观总成或更换维修',
  }, {
    label: 'L1-单个PD前面板,MPPT板,主板,内部结构件等更换维修',
    value: 'L1-单个PD前面板,MPPT板,主板,内部结构件等更换维修',
  }, {
    label: 'L2-两个及以上PD前面板,MPPT板,主板,内部结构件等更换维修',
    value: 'L2-两个及以上PD前面板,MPPT板,主板,内部结构件等更换维修',
  }, {
    label: 'F1翻新(主机完好,更换外观件,调试,校准,升级固件,包装封膜等)',
    value: 'F1翻新(主机完好,更换外观件,调试,校准,升级固件,包装封膜等)',
  }, {
    label: 'F2翻新(整机维修翻新,更换包装等)',
    value: 'F2翻新(整机维修翻新,更换包装等)',
  }],
  3: [{
    label: '质检',
    value: '质检',
  }, {
    label: 'L0- 功能异常机器检测,需拆解机器,对电池包和BMS各输入输出端检测',
    value: 'L0- 功能异常机器检测,需拆解机器,对电池包和BMS各输入输出端检测',
  }, {
    label: 'L1- 功能正常,外观件损坏更换 (上盖更换, 下盖更换, 钥匙丢失更换锁芯)',
    value: 'L1- 功能正常,外观件损坏更换 (上盖更换, 下盖更换, 钥匙丢失更换锁芯)',
  }, {
    label: 'L2- 功能异常,拆解维修更换 (电池包, BMS, 控制板)',
    value: 'L2- 功能异常,拆解维修更换 (电池包, BMS, 控制板)',
  }, {
    label: 'F1- 无故障类机器翻新,检测清洁和包装',
    value: 'F1- 无故障类机器翻新,检测清洁和包装',
  }, {
    label: 'F2- 故障类机器翻新,维修完成后检测清洁和包装 ',
    value: 'F2- 故障类机器翻新,维修完成后检测清洁和包装 ',
  }, {
    label: '報廢',
    value: '報廢',
  }],
  4: [{
    label: '电池 -内部短路-报废',
    value: '电池 -内部短路-报废',
  }, {
    label: '电池 -充电口坏-换充电口-L4',
    value: '电池 -充电口坏-换充电口-L4',
  }, {
    label: '电池 -电池上盖坏-换电池上盖-L4',
    value: '电池 -电池上盖坏-换电池上盖-L4',
  }, {
    label: '电池 -电量显示灯坏-换电量显示灯-L4',
    value: '电池 -电量显示灯坏-换电量显示灯-L4',
  }, {
    label: '后拨链器掉落或卡进轮子里-仅拨链器坏-换拨链器-L3',
    value: '后拨链器掉落或卡进轮子里-仅拨链器坏-换拨链器-L3',
  }, {
    label: '后拨链器掉落或卡进轮子里-车架吊耳坏-换吊耳-L1',
    value: '后拨链器掉落或卡进轮子里-车架吊耳坏-换吊耳-L1',
  }, {
    label: '后拨链器掉落或卡进轮子里-链条坏-换链条-L3',
    value: '后拨链器掉落或卡进轮子里-链条坏-换链条-L3',
  }, {
    label: '后拨链器掉落或卡进轮子里-飞轮卡坏-换飞轮-L2',
    value: '后拨链器掉落或卡进轮子里-飞轮卡坏-换飞轮-L2',
  },{
    label: '脚踩无助力-助力传感器坏-换助力传感器-L2',
    value: '脚踩无助力-助力传感器坏-换助力传感器-L2',
  },{
    label: '刹车太松或失灵-机械碟刹-调紧刹车线-L1',
    value: '刹车太松或失灵-机械碟刹-调紧刹车线-L1',
  },{
    label: '刹车太松或失灵-油压碟刹漏油-加矿物油-L1',
    value: '刹车太松或失灵-油压碟刹漏油-加矿物油-L1',
  },{
    label: '刹车太松或失灵-油压碟刹进气-排气-L1',
    value: '刹车太松或失灵-油压碟刹进气-排气-L1',
  },{
    label: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L2',
    value: '刹车异响-刹车钳磨碟刹盘-调整刹车钳位置-L2',
  },{
    label: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L2',
    value: '刹车异响-刹车摩擦片问题-换刹车摩擦片-L2',
  },{
    label: '电机不启动-刹把断电了-恢复刹把或换断电线-L3',
    value: '电机不启动-刹把断电了-恢复刹把或换断电线-L3',
  },{
    label: '电机不启动-电机坏-换电机-L3',
    value: '电机不启动-电机坏-换电机-L3',
  },{
    label: '电机不启动-控制器坏-换控制器-L3',
    value: '电机不启动-控制器坏-换控制器-L3',
  },{
    label: '电机不启动-主线束坏-换主线束-L3',
    value: '电机不启动-主线束坏-换主线束-L3',
  },{
    label: '后轮摇摆-辐条松-校正辐条-UNABLE',
    value: '后轮摇摆-辐条松-校正辐条-UNABLE',
  },{
    label: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L1',
    value: '后轮摇摆-轮胎线不均匀-放气调整轮胎线-L1',
  },{
    label: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L1',
    value: '前大灯无法关闭-灯和控制器灯模块坏-换灯和控制器-L1',
  },{
    label: '仪表显示故障/屏幕坏--换仪表-L1',
    value: '仪表显示故障/屏幕坏--换仪表-L1',
  },{
    label: '前叉漏油--换前叉-L3',
    value: '前叉漏油--换前叉-L3',
  },{
    label: '曲柄坏--换曲柄-L3',
    value: '曲柄坏--换曲柄-L3',
  },{
    label: '链盘坏--换链盘-L3',
    value: '链盘坏--换链盘-L3',
  },{
    label: '内胎/衬带坏--换内胎/衬带-L3',
    value: '内胎/衬带坏--换内胎/衬带-L3',
  }],
}

const getNoteShortcutOptions = (customer, shortCuts = customerNoteShortcuts) => {
  const value = getOptionValue(customer);
  return shortCuts[value];
}

const requestTypeOptions = [
  { value: 'relaunch', label: 'Relaunch' },
  { value: 'repair', label: 'Repair' },
];

class RMAForm extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      Submit_Description1: '',
      Submit_Description2: '',
      onCustomerEditPage: undefined,
      searchType1: 'Name',
      searchType2: 'Name',
      inTable: {
        rows: [],
      },
      outTable: {
        rows: [],
      },
      amount: '0',
    };

  }

  componentDidMount() {
    if (this.props.route.path === 'customerRMA/:id' || this.props.route.path === 'customerRMA/new') {
      if (isFBD) {
        this.props.fetchCustomers(true);
      } else {
        this.props.fetchCustomers();
      }
      this.setState({
        onCustomerEditPage: true
      })
    } else {
      this.setState({
        onCustomerEditPage: false
      })
    }
    this.props.routeParams.id && this.props.fetchCustomerReturn(this.props.routeParams.id); //If the route contains id search return by id
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentReturnDetail !== this.props.currentReturnDetail) {
      this.initialData(nextProps.currentReturnDetail)
    }
    // if (nextProps.Submit_Description1 !== this.props.Submit_Description1) {
    //   this.setState({
    //     Submit_Description1: nextProps.Submit_Description1,
    //   })
    // }
    // if (nextProps.Submit_Description2 !== this.props.Submit_Description2) {
    //   this.setState({
    //     Submit_Description2: nextProps.Submit_Description2,
    //   })
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.notesShortcut !== this.props.notesShortcut && this.props.notesShortcut) {
      const notes = `${this.props.notesShortcut.value}\n`;
      this.setState({
        Submit_Description1: `${this.state.Submit_Description1}${notes}`,
      });
    }
    if (this.state.amount !== this.replaceTableTotalAmountCalculate()) {
      this.setState({
        amount: this.replaceTableTotalAmountCalculate(),
      })
    }
  }

  initialData = (currentReturnDetail) => {
    const {
      Lines,
      Reason,
      RequestDetails,
    } = currentReturnDetail;
    const inTableRow = Lines.filter(line => line.DetailType === 'in');
    const outTableRow = Lines.filter(line => line.DetailType === 'out');
    this.setState({
      inTable: {
        ...this.state.inTable,
        rows: inTableRow.map((row, idx) => ({ ...row, Index: idx, RefNum: row.SKUNumber })),
      },
      outTable: {
        ...this.state.outTable,
        rows: outTableRow.map((row, idx) => ({ ...row, Index: idx })),
      },
      Submit_Description1: Reason,
      Submit_Description2: RequestDetails,
    })
  }

  replaceTableTotalAmountCalculate = () => {
    const rows = [...this.state.outTable.rows];
    let amount = 0;
    _.forEach(rows, row => {
      amount += (parseFloat(row.UnitPrice) * row.Quantity);
    });
    return amount
  }

  breadcrumb = () => (
    <Breadcrumb style={this.state.crumbStyle}>
      <Breadcrumb.Item>
        <Translate value="rma" />
      </Breadcrumb.Item>
      <Breadcrumb.Item active="true">
        <Translate value="Return_Form" />
      </Breadcrumb.Item>
    </Breadcrumb>
  )
  breadCrumbButton = () => (
    <ButtonToolbar>
      <Button
        bsStyle="success"
        type="submit"
        action="submit"
      >
        <em className="fa fa-save" /><Translate value="save" />
      </Button>
      <Button
        bsStyle="danger"
        type="reset"
        href={this.state.onCustomerEditPage ? '/customerRMA' : '/dispatchRMA'}
      >
        <em className="fa fa-close" /><Translate value="cancel" />
      </Button>
    </ButtonToolbar>
  )

  handleTextareaChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  generateRMALines = () => {
    const lines = [...this.state.inTable.rows, ...this.state.outTable.rows];
    const newLines = _.map(lines, line => {
      return {
        UnitPrice: line.UnitPrice,
        Quantity: line.Quantity,
        DetailType: line.DetailType,
        Product: line.Product_id,
        TotalPrice: line.UnitPrice * line.Quantity,
        ProductNum: line.ProductNum,
        Name: line.Name,
        Id: line.Id || null,
        RMA: line.RMA || null,
        SKUNumber: line.RefNum,
      }
    });
    return newLines;
  }

  generateSKUs = () => {
    let skus = [];
    const lines = [...this.state.inTable.rows];
    _.forEach(lines, line => {
      line.RefNum && skus.push(line.RefNum);
    });
    return skus.join(',');
  }

  handleFormSubmit = (formValues) => {
    const {
      Customer,
      ProcessStatus,
      ReturnTracking,
      Resolution,
      SNNum,
      RequestType,
      RequestDetails,
    } = formValues;
    const {
      Submit_Description1,
      Submit_Description2,
    } = this.state;
    const { 
      customerOptions
    } = this.props;
    const payload = {
      Customer: getOptionValue(Customer),
      CustomerName: getOptionLabel(Customer, customerOptions),
      RequestType: getOptionValue(RequestType),
      SNNum,
      ReturnTracking,
      SKU: this.generateSKUs(),
      Resolution,
      Reason: Submit_Description1,
      RequestDetails: Submit_Description2,
      ProcessStatus: getOptionValue(ProcessStatus),
      rma_line: this.generateRMALines(),
      TotalPrice: this.state.amount,
    };
    const success = () => {
      alert('success redirecting to RMA list page');
      this.props.router.push('/customerRMA');
    }
    const failed = err => {
      alert(JSON.stringify(err));
    }

    if (this.props.routeParams.id) {
      this.props.editRMAOrder(payload, this.props.routeParams.id, success, failed);
    } else {
      this.props.createRMAOrder(payload, success, failed);
    }
  }

  handleSearchTypeChange1 = ({ target }) => {
    this.setState({
      searchType1: target.value,
    })
  }

  handleSearchTypeChange2 = ({ target }) => {
    this.setState({
      searchType2: target.value,
    })
  }

  renderTypeRadio1 = () => {
    return (
      <Row>
        <Col sm={2}>
          <span style={{ fontSize: '15px', fontWeight: 'bold' }}><Translate value="search_by" /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType1"
            type="radio"
            value="ProductNum"
            checked={this.state.searchType1 === "ProductNum"}
            onChange={this.handleSearchTypeChange1}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='prod_num' /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType1"
            type="radio"
            value="RefNum"
            checked={this.state.searchType1 === "RefNum"}
            onChange={this.handleSearchTypeChange1}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='sku_num' /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType1"
            type="radio"
            value="Name"
            checked={this.state.searchType1 === "Name"}
            onChange={this.handleSearchTypeChange1}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='name' /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType1"
            type="radio"
            value="Barcode"
            checked={this.state.searchType1 === "Barcode"}
            onChange={this.handleSearchTypeChange1}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='barcode' /></span>
        </Col>
      </Row>
    )
  }

  renderTypeRadio2 = () => {
    return (
      <Row>
        <Col sm={2}>
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value="search_by" /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType2"
            type="radio"
            value="ProductNum"
            checked={this.state.searchType2 === "ProductNum"}
            onChange={this.handleSearchTypeChange2}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='prod_num' /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType2"
            type="radio"
            value="RefNum"
            checked={this.state.searchType2 === "RefNum"}
            onChange={this.handleSearchTypeChange2}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='sku_num' /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType2"
            type="radio"
            value="Name"
            checked={this.state.searchType2 === "Name"}
            onChange={this.handleSearchTypeChange2}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='name' /></span>
        </Col>
        <Col sm={2}>
          <input
            name="searchType2"
            type="radio"
            value="Barcode"
            checked={this.state.searchType2 === "Barcode"}
            onChange={this.handleSearchTypeChange2}
          />
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}><Translate value='barcode' /></span>
        </Col>
      </Row>
    )
  }

  renderInTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.inTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };
    const that = this;
    const handleRowDelete = (index) => {
      const rows = [...this.state.inTable.rows];
      rows.splice(index, 1);
      this.setState({
        inTable: {
          ...this.state.inTable,
          rows,
        }
      })
    }
    const deleteButton = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={(props) => {
                const Index = this.props.dependentValues.Index;
                handleRowDelete(Index)
              }}
            >X
            </Button>
          </span>
        );
      },
    });

    const productCol = [{
      name: <Translate value="del" />,
      width: 50,
      formatter: deleteButton,
      getRowMetaData: row => row,
    }, {
      key: 'ProductNum',
      name: <Translate value="product_num" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
      editable: true,
    }, {
      key: 'RefNum',
      name: <Translate value="sku_num" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
      editable: true,
    }, {
      key: 'Name',
      name: <Translate value="name" />,
      resizable: true,
      sortable: true,
      width: 120,
      filterable: true,
      editable: true,
    }, {
      key: 'Quantity',
      name: <Translate value="quantity" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      editable: true,
    }, {
      key: 'UnitPrice',
      name: <Translate value="price" />,
      resizable: true,
      sortable: true,
      width: 50,
      filterable: true,
      editable: true,
    }]


    const handleRowUpdated = ({ rowIdx, updated }) => {
      const inTable = { ...this.state.inTable };
      inTable.rows[rowIdx] = {
        ...inTable.rows[rowIdx],
        ...updated,
      };
      this.setState({
        inTable,
      })
    };

    return (
      <ReactDataGrid
        rowKey="ProductNum"
        // onGridSort={handleGridSort}
        columns={productCol}
        rowHeight={25}
        headerRowHeight={45}
        rowGetter={rowGetter}
        rowsCount={getSize()}
        enableCellSelect
        // enableRowSelect="multi"
        // toolbar={<Toolbar enableFilter />}
        // onAddFilter={handleFilterChange}
        // onClearFilters={onClearFilters}
        minHeight={220}
        onRowUpdated={handleRowUpdated}
      // onRowClick={onRowClick}
      // rowSelection={{
      //   showCheckbox: true,
      //   onRowsSelected,
      //   onRowsDeselected,
      //   selectBy: {
      //     isSelectedKey: 'isSelected',
      //   },
      // }}
      />
    )
  }

  renderOutTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.outTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleRowUpdated = ({ rowIdx, updated }) => {
      const outTable = { ...this.state.outTable };
      outTable.rows[rowIdx] = {
        ...outTable.rows[rowIdx],
        ...updated,
      };
      this.setState({
        outTable,
      })
    };

    const that = this;
    const handleRowDelete = (index) => {
      const rows = [...this.state.outTable.rows];
      rows.splice(index, 1);
      this.setState({
        outTable: {
          ...this.state.inTable,
          rows,
        }
      })
    }
    const deleteButton = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={(props) => {
                const Index = this.props.dependentValues.Index;
                handleRowDelete(Index)
              }}
            >X
            </Button>
          </span>
        );
      },
    });

    const productCol = [{
      name: <Translate value="del" />,
      width: 50,
      formatter: deleteButton,
      getRowMetaData: row => row,
    }, {
      key: 'ProductNum',
      name: <Translate value="product_num" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
      editable: true,
    }, {
      key: 'RefNum',
      name: <Translate value="sku_num" />,
      resizable: true,
      sortable: true,
      width: 100,
      filterable: true,
      editable: true,
    }, {
      key: 'Name',
      name: <Translate value="name" />,
      resizable: true,
      sortable: true,
      width: 120,
      filterable: true,
      editable: true,
    }, {
      key: 'Quantity',
      name: <Translate value="quantity" />,
      resizable: true,
      sortable: true,
      width: 80,
      filterable: true,
      editable: true,
    }, {
      key: 'UnitPrice',
      name: <Translate value="price" />,
      resizable: true,
      sortable: true,
      width: 50,
      filterable: true,
      editable: true,
    }];

    return (
      <ReactDataGrid
        // rowKey="Product_id"
        // onGridSort={handleGridSort}
        columns={productCol}
        rowHeight={25}
        headerRowHeight={45}
        rowGetter={rowGetter}
        rowsCount={getSize()}
        enableCellSelect
        // enableRowSelect="multi"
        // toolbar={<Toolbar enableFilter />}
        // onAddFilter={handleFilterChange}
        // onClearFilters={onClearFilters}
        minHeight={220}
        onRowUpdated={handleRowUpdated}
      // onRowClick={onRowClick}
      // rowSelection={{
      //   showCheckbox: true,
      //   onRowsSelected,
      //   onRowsDeselected,
      //   selectBy: {
      //     isSelectedKey: 'isSelected',
      //   },
      // }}
      />
    )
  }

  handleProductSelect1 = (product) => {
    if (!product) return;
    this.setState({
      inTable: {
        ...this.state.inTable,
        rows: [...this.state.inTable.rows, {
          ...product,
          Quantity: '1',
          DetailType: 'in',
          UnitPrice: product.Price,
        }].map((line, idx) => ({
          ...line,
          Index: idx,
        }))
      }
    })
  }

  handleProductSelect2 = (product) => {
    if (!product) return;
    this.setState({
      outTable: {
        ...this.state.outTable,
        rows: [...this.state.outTable.rows, {
          ...product,
          Quantity: '1',
          DetailType: 'out',
          UnitPrice: product.Price,
        }].map((line, idx) => ({
          ...line,
          Index: idx,
        }))
      }
    })
  }


  renderForm = () => {
    const returnDetail = (<h2><Translate value="return_details" /></h2>);
    const {
      customerOptions,
      Customer,
    } = this.props;
    const {
      searchType,
    } = this.state;
    const customerId = Customer && (Customer.value || Customer)
    return (
      <Col sm={12}>
        <Panel header={returnDetail} style={{ height: '800px' }}>
          <Row>
            <Col sm={6}>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="Customer_Name" /><span className="asteriksReq">*</span></label>
                  <div className="col-sm-7">
                    <Field name="Customer" component={Selection} options={customerOptions} />
                  </div>
                </div>
              </Row>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="request_type" /><span className="asteriksReq">*</span></label>
                  <div className="col-sm-7">
                    <Field name="RequestType" component={Selection} options={requestTypeOptions} />
                  </div>
                </div>
              </Row>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="status" /></label>
                  <div className="col-sm-7">
                    <Field name="ProcessStatus" component={Selection} options={processStatus} />
                  </div>
                </div>
              </Row>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="return_tracking" /></label>
                  <div className="col-sm-7">
                    <Field name="ReturnTracking" component={InputField} />
                  </div>
                </div>
              </Row>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="sn_num" /></label>
                  <div className="col-sm-7">
                    <Field name="SNNum" component={InputField} />
                  </div>
                </div>
              </Row>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="resolution" /></label>
                  <div className="col-sm-7">
                    <Field name="Resolution" component={InputField} />
                  </div>
                </div>
              </Row>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="total_amount" /></label>
                  <div className="col-sm-7">
                    {/* <input 
                      type="text"
                      style={{ height: '24px', borderRadius: '5px' }}
                      disabled
                      value={this.state.amount}
                    /> */}
                    {this.state.amount}
                    <span style={{ paddingLeft: '5px' }}>$</span>
                  </div>
                </div>
              </Row>
              <Row className="form-horizontal">
                <div className="form-group">
                  <label className="col-sm-4"><Translate value="notes_shortcut" /></label>
                  <div className="col-sm-7">
                    <Field name="notesShortcut" component={Selection} options={getNoteShortcutOptions(Customer)} />
                  </div>
                </div>
              </Row>
              <Row>
                <div className="form-group">
                  <label className="col-sm-2" htmlFor="textarea1"><Translate value="notes" /></label>
                  <div className="col-sm-9">
                    <textarea onChange={this.handleTextareaChange} value={this.state.Submit_Description1} name="Submit_Description1" className="form-control" id="textarea1" style={{ width: '100%', height: '200px' }} />
                  </div>
                </div>
              </Row>
              <Row>
                <div className="form-group">
                  <label className="col-sm-2" htmlFor="textarea2"><Translate value="request_details" /></label>
                  <div className="col-sm-9">
                    <textarea disabled onChange={this.handleTextareaChange} value={this.state.Submit_Description2} name="Submit_Description2" className="form-control" id="textarea2" style={{ width: '100%', height: '100px' }} />
                  </div>
                </div>
              </Row>
            </Col>

            <Col sm={6}>
              <Row style={{ marginBottom: '20px' }}>
                <Col sm={11}>
                  <div style={{ color: 'brown', fontWeight: 'bold', fontSize: '22px', display: 'inline-blick', height: '30px' }}><Translate value="products_repaired" /></div>
                  {this.renderTypeRadio1()}
                  <Row style={{ height: '40px' }}>
                    <Col>
                      <RMAAutoSuggest
                        customerId={customerId}
                        searchType={this.state.searchType1}
                        handleProductSelect={this.handleProductSelect1}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {this.renderInTable()}
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col sm={11}>
                  <div style={{ color: 'brown', fontWeight: 'bold', fontSize: '22px', display: 'inline-blick', height: '30px' }}><Translate value="products_cost" /></div>
                  {this.renderTypeRadio2()}
                  <Row style={{ height: '40px' }}>
                    <Col>
                      <RMAAutoSuggest
                        customerId={customerId}
                        searchType={this.state.searchType2}
                        handleProductSelect={this.handleProductSelect2}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {this.renderOutTable()}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Panel>
      </Col>
    )
  }



  render() {
    const returnDetail = (<h2><Translate value="return_details" /></h2>);
    const repairDetail = (<h2><Translate value="repair_detail" /></h2>);
    const shippingDetail = (<h2><Translate value="shipping_detail" /></h2>);
    const { handleSubmit, submitting, pristine, Fix_Status } = this.props;
    const FixStatusIsUnreceived = Fix_Status === "UNRECEIVED" || !Fix_Status;
    return (
      <ContentWrapper>
        <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} >
          {this.breadcrumb()} {/* BreadCrumb */}
          {this.breadCrumbButton()} {/* Breadcrumb Buttons */}
          <Grid id="vendor-form">{/* Return Details start */}
            <Row>
              {this.renderForm()}
            </Row>
          </Grid>
        </form>
      </ContentWrapper>);
  }
}

export default RMAForm;



// WEBPACK FOOTER //
// ./master/jsx/components/RMA/rmaForm.jsx